import { render, staticRenderFns } from "./shopInvoice.vue?vue&type=template&id=018fa7c8&scoped=true&"
import script from "./shopInvoice.vue?vue&type=script&lang=js&"
export * from "./shopInvoice.vue?vue&type=script&lang=js&"
import style0 from "./shopInvoice.vue?vue&type=style&index=0&id=018fa7c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018fa7c8",
  null
  
)

export default component.exports